import { GoArrowDown } from "react-icons/go";

function Contact(){
    return(
        <section id='contact'>
            <div className="container">
                    <div className="get">
                        <hr />
                        <h1>Get In Touch <GoArrowDown /></h1>
                    </div>

                    <div className="donne">
                        <hr />
                        <h1>ot_zerroug@esi.dz</h1>
                        <ul className="social">
                            <li><a href="https://www.instagram.com/tedjjjj69/" target="_blank" rel="noreferrer">Instagram</a></li>
                            <li><a href="https://www.linkedin.com/in/zerroug-tadj-el-islem-566a453ab/" target="_blank" rel="noreferrer">LinkedIn</a></li>
                            <li><a href="https://github.com/tedjjj" target="_blank" rel="noreferrer">Github</a></li>
                            <li><a href="mailto:ot_zerroug@esi.dz" target="_blank" rel="noreferrer">Email</a></li>
                        </ul>

                        <ul className="infoo">
                            <li>Located In</li>
                            <li>Setif / Algiers, Algeria</li>
                            <li>+213 54 97 24 816</li>
                        </ul>
                    </div>

                    <nav className="icons">
                        <ul>
                        <a href="https://www.instagram.com/tedjjjj69/" target="_blank" rel="noreferrer">
                            <img className="inst" src="/inst.png" alt="Instagram logo"></img>
                        </a>
                        <a href="https://www.linkedin.com/in/zerroug-tadj-el-islem-566a453ab/" target="_blank" rel="noreferrer">
                            <img className="link" src="/linkden.png" alt="LinkedIn logo"></img>
                        </a>
                        <a href="https://github.com/tedjjj" target="_blank" rel="noreferrer">
                            <img className="git" src="/git.png" alt="GitHub logo"></img>
                        </a>
                        <a href="mailto:ot_zerroug@esi.dz" target="_blank" rel="noreferrer">
                            <img className="disc" src="/discord.png" alt="Discord logo"></img>
                        </a>
                        </ul>
                    </nav>
            </div>
        </section>
    )
}


export default Contact ; 
